<!--
 * @Author: p_fy
 * @Date: 2019-07-18 17:22:46
 * @LastEditors: l_hc
 * @LastEditTime: 2019-10-18 18:26:56
 * @Description: 成交窗口，提交仓库成交信息。
 -->
<!-- 成交 -->
<template>
  <div class="transport-news">
    <el-dialog
      :visible.sync="dealVisible"
      title="成交"
      width="600px"
      @close="$emit('close', false)"
    >
      <div class="deal-wrap">
        <span>成交订单</span>
        <span>请您认证填写成交订单信息!</span>
      </div>
      <ul class="deal-ul">
        <el-form ref="form" :model="form" :rules="formRules" label-width="83px">
          <el-form-item label="租赁时间" prop="leasetime">
            <el-date-picker
              v-model="form.leasetime"
              :picker-options="pickerOptions"
              type="daterange"
              :editable="false"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              style="width: 100%;"
              @change="timeChange"
            />
          </el-form-item>
          <el-row :gutter="20" style="text-align: center;">
            <el-col :span="12">
              <el-form-item label="支付方式" prop="payType">
                <el-select v-model="form.payType" placeholder="请选择" style="width:100%">
                  <el-option
                    v-for="(item,index) in payType"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item v-if="dealType == '1'" label="租用面积" prop="rentalArea">
                <el-input-number v-model="form.rentalArea" controls-position="right" :min="dealData.lettableArea" :max="dealData.rentableArea" style="width:100%;" @change="handleChange" />
              </el-form-item>
              <el-form-item v-if="dealType != '1'" label="租用罐数" prop="rentalIrrigation">
                <el-input-number v-model="form.rentalIrrigation" controls-position="right" :min="dealData.lettableArea" :max="dealData.rentableArea" style="width:100%;" @change="handleChange" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20" style="text-align: center;">
            <el-col :span="12">
              <el-form-item v-if="dealType == '1'" label="可租用面积">
                {{ dealData.rentableArea }}m²
              </el-form-item>
              <el-form-item v-if="dealType != '1'" label="罐区容积">
                {{ dealData.potArea }}m³
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="租赁天数">
                {{ form.days }}天
                <!-- <el-input v-model="form.name" :disabled="true" /> -->
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="总价" style="color: #be2316;">
                {{ form.totalPrice }}元
                <!-- <el-input v-model="form.name" :disabled="true" /> -->
              </el-form-item>
            </el-col>
          </el-row>
          <div style="text-align: center;">
            <el-button type="danger" plain size="small" @click="dealSave">提交</el-button>
          </div>
        </el-form>
      </ul>
    </el-dialog>
  </div>
</template>
<script>
import { saveStorageOrder, findByUserIdAndCompanyName, getDict } from '@/api/personal/store/storeDeal'
import { mapGetters } from 'vuex'
import moment from 'moment'
export default {
  name: 'DealWarehousing',
  components: {
  },
  props: {
    dealManager: { type: Boolean, default: () => false }, // 弹窗控制
    dealData: { type: Object, default: () => {} }, // 当前预约元素
    demandData: { type: Object, default: () => null }, // 当前预约元素
    dealType: { type: String, default: () => { '' } } // 当前预约元素
  },
  data() {
    return {
      userId:'',
      dealVisible: this.dealManager,
      payType: [],
      pickerOptions: {
        disabledDate(time) {
          console.log(Date.now())
          return time.getTime() < Date.now() - 1000 * 60 * 60 * 24
        }
      },
      form: {
        leasetime: null,
        days: 0,
        totalPrice: 0,
        rentalArea: 0,
        rentalIrrigation: 0
      },
      formRules: {
        leasetime: [{ required: true, message: '请选择租赁时间' }],
        payType: [{ required: true, message: '请选择支付方式', trigger: 'change' }]
      },
      companyInfo: {
        id: null,
        companyName: null
      },
      demandInfo: null
    }
  },
  computed: {
    ...mapGetters(['userType', 'userInfo'])
  },
  watch: {
    dealManager() {
      this.dealVisible = this.dealManager
      if (this.dealManager) {
        if (this.dealType == '1') {
          this.form.rentalArea = this.dealData.lettableArea
        } else {
          this.form.rentalIrrigation = this.dealData.leasePotCount
        }
      } else {
        this.$refs['form'].resetFields()
        this.form = {
          leasetime: null,
          days: 0,
          totalPrice: 0,
          rentalArea: 0,
          rentalIrrigation: 0
        }
      }
    },
    demandData() {
      this.demandInfo = this.demandData
    },
    'form.days': {
      handler: function(val) {
        this.totalPriceShow()
      }
    },
    'form.rentalArea': {
      handler: function(val) {
        this.totalPriceShow()
      }
    },
    'form.rentalIrrigation': {
      handler: function(val) {
        this.totalPriceShow()
      }
    },
    'form.leasePotCount': {
      handler: function(val) {
        this.totalPriceShow()
      }
    }
  },
  created() {
    (async() => {
      if (this.userType != '') {
        await this.companyfindInfo()
      }
      await this.getPayType()
    })()
  },
  methods: {
    // 支付方式
    getPayType() {
      getDict('payType').then(res => {
        const payType = JSON.parse(res.result)
        if (payType.length > 0) {
          payType.forEach(res => {
            this.payType.push({
              label: res.label,
              value: res.value
            })
          })
        }
      }).catch(err => {
        console.error(err)
      })
    },
    // 计算总价
    totalPriceShow() {
      if (parseInt(this.form.days) <= 0) {
        return false
      }
      if (this.dealType == '1') {
        this.form.totalPrice = (this.dealData.expectPrice * this.form.rentalArea * this.form.days)
      } else {
        this.form.totalPrice = (this.dealData.expectPrice * this.form.rentalIrrigation * this.dealData.potArea * this.form.days)
      }
      console.log(this.form.totalPrice)
    },
    // 根据Uid查询企业信息
    companyfindInfo() {
      findByUserIdAndCompanyName().then(res => {
        console.log('1111111111111111111111',res.user.userId)
        this.companyInfo = res.result
        console.log( res)
       this.userId=res.user.userId
      }).catch((err) => {
        console.log(err)
      })
    },
    timeChange(dataArr) {
      let dateSpan = dataArr[0] - dataArr[1]
      dateSpan = Math.abs(dateSpan)
      const iDays = Math.floor(dateSpan / (24 * 3600 * 1000))
      this.form.days = iDays
    },
    handleChange(value) {
      // console.log(value)
    },
    dealSave() {
      console.log(this.companyInfo,'1111111111')
      if (this.companyInfo == null) {
        this.companyfindInfo()
        return false
      }
      this.$refs['form'].validate((valid) => {
        if (valid) {
          const params = {
              userId:this.userId,
            supplyId: this.dealData.id,
            demandCompanyId: this.companyInfo.id,
            orderType: this.dealType,
            leaseStartTime: moment(this.form.leasetime[0]).format('YYYY-MM-DD'),
            leaseEndTime: moment(this.form.leasetime[1]).format('YYYY-MM-DD'),
            leaseDay: this.form.days,
            payType: this.form.payType,
            money: this.dealData.expectPrice,
            demandInfo: this.demandInfo != null ? this.demandInfo.id : this.demandInfo
          }
          if (this.dealType == '1') {
            params.leaseArea = this.form.rentalArea 
          } else {
            params.leaseCubage = this.dealData.potArea
            params.leasePotCount = this.form.rentalIrrigation
          }
          saveStorageOrder(params).then(res => {
            // 成功提示
            this.$message({
              showClose: true,
              offset: 100,
              message: '恭喜你，已成交',
              type: 'success'
            })
            this.$emit('closeSuccess', false)
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>

<style scoped lang='scss'>
  $o: "deal-";
  $main-color: #be2316;
  .transport-news{
    margin-bottom: 1rem;
  }
  /deep/.#{$o}wrap{
    display: grid;
    text-align: center;
    span{
      font-family:MicrosoftYaHei;
      font-weight:600;
      line-height:39px;
      &:nth-child(1){
        font-size:18px;
        color:rgba(190,35,22,1);
      }
      &:nth-child(2){
        font-size:14px;
        color:rgba(153,153,153,1)
      }
    }
  }
  /deep/.#{$o}ul{
    margin: 10px 0px 0px 0px;
    >li{
      font-size:14px;
      font-family:MicrosoftYaHei;
      font-weight:400;
      color:rgba(85,85,85,1);
      line-height:33px;
    }
  }
</style>

